import {Injectable} from '@angular/core';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:UtilsService'));

@Injectable()
export class UtilsService {

    private _verbose = null;
    
    constructor() {
        // 'Construct utils services' );
    }
    
    public getElementToWindowOffset (element) {
        debugOff( 'Get element offset to window' );

        var xPosition = 0;
        var yPosition = 0;

        while (element) {
            xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
            yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
            element = element.offsetParent;
        }

        return { x: xPosition, y: yPosition };
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/utils-service.ts